import React from 'react'
import { FormattedMessage } from 'react-intl'
import { sendHeaderMenuEvents } from '@utils/analytics'
import { useCurrentUser } from '@utils/useCurrentUser'
import getConfig from 'next/config'
import { Abilities, useAbility } from '@utils/useAbility'
import {
  quickOrderRoute,
  orderLookupRoute,
  orderCenterRoutes,
} from '@src/routes'
import { Link } from '@src/components/Link'
import MiniCart from '../MiniCart'
import AccountMenu from './AccountMenu'
import { makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  headerBottomRightNav: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: theme.spacing(30),
    alignItems: 'center',
    flexGrow: 1,
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      marginLeft: theme.spacing(25),
    },
  },
  navRightItem: {
    display: 'flex',
    flexShrink: 0,
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    borderRight: `2px solid ${theme.palette.brand.light}`,
    alignItems: 'center',
  },
  navRightCart: {
    paddingLeft: theme.spacing(5),
  },
  navLink: {
    color: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.common.white,
    },
  },
}))

const HeaderBottomRightNav = () => {
  const classes = useStyles()
  const { currentUserLoading, currentUser, isOrderStatusCustomer } =
    useCurrentUser()

  const {
    publicRuntimeConfig: { featureFlags },
  } = getConfig()
  const { authorized } = useAbility(Abilities.canAddToCart)
  return (
    <div className={classes.headerBottomRightNav}>
      {!currentUserLoading && (
        <>
          <AccountMenu isAuthorized={authorized} />
          {authorized && (
            <>
              {featureFlags.orderLookup && (
                <>
                  <div className={classes.navRightItem}>
                    {}
                    <Link href={orderLookupRoute.index()}>
                      <a
                        className={classes.navLink}
                        onClick={() =>
                          sendHeaderMenuEvents({
                            menu: {
                              id: 'ORDER_LOOKUP',
                              defaultMessage: 'Order Lookup',
                            },
                            linkUrl:
                              currentUser?.__typename !== 'LoggedInUser'
                                ? orderLookupRoute.index()
                                : isOrderStatusCustomer
                                  ? orderCenterRoutes.orderSearch()
                                  : orderCenterRoutes.orders(),
                          })
                        }
                        data-testid="header-order-lookup-link"
                        id="header-order-lookup-link"
                      >
                        <FormattedMessage
                          id="ORDER_LOOKUP"
                          defaultMessage="Order Lookup"
                        />
                      </a>
                    </Link>
                  </div>
                </>
              )}
              <div className={classes.navRightItem}>
                {}
                <Link href={quickOrderRoute.index()}>
                  <a
                    className={classes.navLink}
                    onClick={() =>
                      sendHeaderMenuEvents({
                        menu: {
                          id: 'QUICK_ORDER',
                          defaultMessage: 'Quick Order',
                        },
                        linkUrl: quickOrderRoute.index(),
                      })
                    }
                    data-testid="header-quick-order-link"
                    id="header-quick-order-link"
                  >
                    <FormattedMessage
                      id="QUICK_ORDER"
                      defaultMessage="Quick Order"
                    />
                  </a>
                </Link>
              </div>
              <div className={classes.navRightCart}>
                {' '}
                <MiniCart id="show-mini-cart-menu-button-desktop" />{' '}
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default HeaderBottomRightNav
